import React from 'react';

// Utils
import PropTypes from 'prop-types';

// Components
import * as S from './Styled';
import Icon from '../../Icon';
import Message from '../Message';

const defaultProps = {
  iconName: 'clock',
};

const propTypes = {
  children: PropTypes.string.isRequired,
};

const Info = ({ children, iconName, msgTitle, msgText }) => {
  return (
    <S.ExtLabel>
      <S.Icon>
        <Icon name={iconName} />
      </S.Icon>
      <S.Text>{children}</S.Text>
      <Message title={msgTitle} text={msgText} />
    </S.ExtLabel>
  );
};

Info.defaultProps = defaultProps;
Info.propTypes = propTypes;

export default Info;
